import React from 'react'
import Link from 'gatsby-link'

import IntroShow from '../components/IntroShow'
import Project from '../components/Project'
import Connect from '../components/Connect'

import profilePic from '../images/brad.png'
import codePen from '../images/Codepen.png'
import gitHub from '../images/GitHub.png'
import homeApp from '../images/homeApp.png'
import linkedIn from '../images/linkedInLogo.png'
import BallinApp from '../images/BallinApp.png'

const IndexPage = () => (
  <div>
    <div className="jumbotronFade">
      <div className="container">
        <div className="row justify-content-sm-center">
          <div className="col-xs-auto">
            <img src={profilePic} className="myPic img-fluid" />
          </div>
        </div>
        <div className="row justify-content-sm-center">
          <div className="col-xs-12">
            <div className="intro">
              <h1>Hi, my name is </h1>
              <h1>Brad </h1>
              <h1> and I am a</h1>
            </div>
            <IntroShow />
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid">
      <div className="row">
        <div className="col align-self-center">
          <h1 className="myWork">My Work</h1>
        </div>
      </div>
      <div className="row ">
        <Project
          image={BallinApp}
          link="https://still-inlet-76133.herokuapp.com/"
          tech={['Node', 'Handlebars', 'Express', 'Passport']}
        />
        <Project
          image={homeApp}
          link="https://myhome-app.herokuapp.com/login"
          tech={['React', 'MongoDB', 'Meteor.js', 'Bootstrap']}
        />
      </div>
      <div className="row socLink">
        <Connect pic="https://codepen.io/bhank/" image={codePen} />
        <Connect pic="https://github.com/bhankee" image={gitHub} />
        <Connect
          pic="ttps://www.linkedin.com/in/brad-hankee"
          image={linkedIn}
        />
      </div>
    </div>
    <div className="container-fluid" />
    <div className="container-fluid">
      <div className="row bottomFooter">
        <div className="col-xs-6 col-md-6 footer">
          <p>Copyright &copy; Brad Hankee 2018</p>
        </div>
        <div className="col-xs-6 col-md-6 footer">
          <ul className="footer">
            <li>
              Made with
              <span className="fa fa-coffee" />by Brad Hankee
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js